import { render } from "./VueCheck.vue?vue&type=template&id=24d87ceb&scoped=true"
import script from "./VueCheck.vue?vue&type=script&lang=js"
export * from "./VueCheck.vue?vue&type=script&lang=js"

import "./VueCheck.vue?vue&type=style&index=0&id=24d87ceb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d87ceb"]])

export default __exports__